// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { LoadingState } from '@/_models/virtualStaging/VSObject';
import { createHTMLMesh } from '@/_models/virtualStaging/HTMLMesh/HTMLMesh';
import { InteractiveGroup } from '@/_models/virtualStaging/HTMLMesh/utils/InteractiveGroup';
import { getXZCoordinatesOnCircle } from '@/components/util/math/getXZCoordinatesOnCircle';
import { AbstractHTMLMesh } from '@/_models/virtualStaging/HTMLMesh/component/AbstractHTMLMesh';
import { Inputs } from '@/_models/virtualStaging/HTMLMesh/component/Backpack/types';

export class BackpackMeshComponent extends AbstractHTMLMesh {
  private hostPose;

  public mesh;

  inputs: Inputs = {
    html: null,
    visible: false,
    scale: 1,
    refs: null,
  };

  onInit() {
    const { html } = this.inputs;
    this.initMesh(html);
    this.initRoot();
    this.addMeshPointerEvents();
    this.getXRController();
    this.outputs.loadingState = LoadingState.Loaded;
  }

  initMesh(html) {
    this.mesh = createHTMLMesh(html, this.context.three);
    this.mesh.material.side = this.context.three.DoubleSide;
    this.mesh.material.depthWrite = false;
    this.mesh.material.depthTest = false;
    this.mesh.renderOrder = 980;
    this.mesh.scale.setScalar(2);
    this.mesh.userData = { isPointerOver: false };
  }

  addMeshPointerEvents() {
    const group = new InteractiveGroup(this.context.renderer, this.context.camera, this.context);
    this.pivot.add(group);
    group.add(this.mesh);
  }

  setHostPose(pose) {
    this.hostPose = pose;
  }

  setPositionFromPose(pose) {
    const { x, z } = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180);
    this.root.position.set(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z);
    this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
  }

  setFromHostPose() {
    this.setPositionFromPose(this.hostPose);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  cycleVR(_session) {
    if (this.gamepadL?.buttons[4]?.pressed && this.hostPose && !this.gamepadButtonActive) {
      this.setVisible(!this.inputs.visible);
      this.setFromHostPose();
      this.gamepadButtonActive = true;
    }
    if (!this.gamepadL?.buttons[4]?.pressed && this.gamepadButtonActive) {
      this.gamepadButtonActive = false;
    }
  }

  onTick() {
    if (this.context?.renderer?.xr?.isPresenting) {
      const _session = this.context.renderer.xr.getSession();
      _session.requestAnimationFrame(() => this.cycleVR(_session));
    }
  }
}

export const backpackMeshComponentType = 'mp.backpackMeshComponent';
export const makeBackpackMeshComponent = (): any => new BackpackMeshComponent();
